export default __webpack_public_path__ + "static/media/home-yoga-meditation-slider-women.5e141d83.png";